// support ie11
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

// React && Redux
import React from "react";
import { hydrate } from "react-dom";
import { Router } from "react-router";
import { createBrowserHistory } from "history";
import {
  StylesProvider,
  createGenerateClassName,
} from "@material-ui/core/styles";

// Container
import LabLookup from "./components/templates/LabLookup";

// create a history object for the client
const history = createBrowserHistory();

const generateClassName = createGenerateClassName({
  productionPrefix: "lab-lookup", // Prevents generic 'jss' collisions
  seed: "mptc", // Guarantees deterministic indices
});

const Main = () => {
  React.useEffect(() => {
    const jssStyles = document.querySelector("#jss-server-side");
    if (jssStyles) {
      jssStyles.parentElement.removeChild(jssStyles);
    }
  }, []);

  return (
    <StylesProvider generateClassName={generateClassName} injectFirst>
      <Router history={history}>
        <LabLookup />
      </Router>
    </StylesProvider>
  );
};
// re-hydrate to use server HTML rather than generate DOM
hydrate(<Main />, document.getElementById("root"));

// enable hot swapping of modules to view changes live
if (module.hot) {
  module.hot.accept("./components/templates/LabLookup", () => {
    hydrate(<Main />, document.getElementById("root"));
  });
}
